import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GreenroomState as GS } from '../../../stores/types/types';
import MainVideoContainer from '../../main-video/main-video-container';
import Socket from '../../../connection/socket';
import DebugPanel from '../../debug-views/debug-panel/panel';
import { OpenTokContext } from '../../../contexts/opentok/opentok-context';
import WaitingIndicator from '../../general-components/waiting-indicator';
import { setRoomState } from '../../../stores/actions/meeting';
import useKickLocationPublishers from './use-kick-location-publishers';

interface Props {
	socket: Socket | null;
	devicesChecked?: boolean;
}

export default function OnsiteLocationCanvas({ socket, devicesChecked = false }: Props) {
	const dispatch = useDispatch();

	const debugEnabled = useSelector((s: GS) => s.DebugReducer.debugEnabled);
	const sessionInitialized = useSelector((s: GS) => s.OpenTokReducer.sessionInitialized);
	const shotsLoaded = useSelector((s: GS) => s.ShotsReducer.shotsLoaded);
	const shots = useSelector((s: GS) => s.ShotsReducer.shots);
	const mediaLoaded = useSelector((s: GS) => s.MediaReducer.mediaLoaded);
	const mediaPagesLoaded = useSelector((s: GS) => s.MediaReducer.mediaPagesLoaded);
	const hasSynced = useSelector((s: GS) => s.SettingsReducer.hasSynced);
	const roomState = useSelector((s: GS) => s.MeetingReducer.roomState);
	const roomStateEntity = useSelector((s: GS) => s.MeetingReducer.roomStateEntity);
	const limitedInput = useSelector((s: GS) => s.SessionReducer.limitedInput);

	const [loadingRoomContent, setLoadingRoomContent] = useState<boolean>(true);

	useKickLocationPublishers();

	const {
		initialSetup,
		forceFeedsTabRefresh,
	} = useContext(OpenTokContext);

	useEffect(() => {
		if (
			mediaLoaded
			&& mediaPagesLoaded
			&& shotsLoaded
			&& shots[0]
			&& hasSynced
		) {
			setLoadingRoomContent(false);
		}
	}, [mediaLoaded, shotsLoaded, shots, hasSynced]);

	useEffect(() => {
		if (roomStateEntity && roomStateEntity.entityValue.roomState !== roomState) {
			dispatch(setRoomState(roomStateEntity.entityValue.roomState));
		}
	}, [roomStateEntity, roomState]);

	useEffect(() => {
		// do not attempt to start until we are certain we have an opentok session id
		if (
			!loadingRoomContent
			&& !forceFeedsTabRefresh
			&& sessionInitialized
			&& (!limitedInput || (limitedInput && devicesChecked))
		) {
			initialSetup();
		}
	}, [
		loadingRoomContent,
		forceFeedsTabRefresh,
		sessionInitialized,
		limitedInput,
		devicesChecked,
	]);

	return (
		<div className="wrapper animate embed">
			{loadingRoomContent ? (
				<WaitingIndicator />
			) : (
				<div className = "meeting-wrapper">
					{!!debugEnabled && <DebugPanel socket={socket} />}
					<div className="meeting-body">
						<div className="left-panel">
							<MainVideoContainer
								socket={socket}
							/>
						</div>
					</div>
				</div>
			)}
		</div>
	);
}
